export const buttonStyles = {
    root: {
        marginRight: 8
    }
};